import React from "react";
import { motion } from "framer-motion";
import { COMMERCIAL_IMAGES } from "@/data/images";

const capabilities = [
  "Full Truckload (FTL) & dedicated routes",
  "Warehousing, load/unload & cross-docking",
  "Load board services & freight transportation",
  "24/7 dispatch support — nationwide delivery",
];

export function BrandShowcase() {
  return (
    <section className="py-20 lg:py-28 border-b border-slate-200" data-testid="commercial-brand-showcase">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-3">Your Cargo. Our Commitment.</div>
          <h2 className="font-heading text-3xl md:text-4xl font-black tracking-tight text-slate-900">
            Full truckload solutions, coast to coast.
          </h2>
          <p className="mt-4 text-slate-600">
            Dry van, reefer, flatbed, power only, and dedicated routes — backed by professional
            drivers, well-maintained equipment, and a dispatch desk that never sleeps.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="border border-slate-200 bg-white p-3 sm:p-4"
        >
          <img
            src={COMMERCIAL_IMAGES.brandLandscape}
            alt="Laronta Pro Logistic LLC — full truckload solutions, warehousing, and nationwide delivery"
            className="w-full h-auto"
            loading="lazy"
            data-testid="commercial-brand-image-1"
          />
        </motion.div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7 border border-slate-200 bg-white p-3 sm:p-4"
          >
            <img
              src={COMMERCIAL_IMAGES.brandSquare}
              alt="Laronta Pro Logistic LLC — drivers, fleet, maintenance, and dispatch operations"
              className="w-full h-auto"
              loading="lazy"
              data-testid="commercial-brand-image-2"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <h3 className="font-heading text-2xl md:text-3xl font-black tracking-tight text-slate-900">
              Safe. Reliable. On time. Every time.
            </h3>
            <p className="mt-4 text-slate-600 leading-relaxed">
              From the wheel to the warehouse to the dispatch desk, every part of our operation
              carries the Laronta Pro name — and we protect it on every load.
            </p>
            <ul className="mt-6 space-y-3">
              {capabilities.map((c) => (
                <li key={c} className="flex items-start gap-3 text-slate-800">
                  <span className="h-1.5 w-6 bg-primary-brand mt-2 flex-none" />
                  <span className="text-sm">{c}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
